var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#395BA9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1761 16.4335L14.3691 12.5173C10.5461 8.44219 14.9314 6 14.9314 6C11.2629 7.19941 10.8131 10.3208 10.8131 10.3208C10.3774 13.3121 12.5138 14.8006 12.5138 14.8006L16.6742 18.2254C21.3266 22.3005 16.3509 26 16.3509 26C20.68 25.3641 21.1579 21.7658 21.1579 21.7658C21.7482 18.6735 19.162 16.4191 19.162 16.4191L19.1761 16.4335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.3383504c0226155b0b4b446ab496a6a3.svg";
export { ForwardRef as ReactComponent };